import { FieldLabel, Select, TextInput } from '../../components/Primitives.jsx';
import { Segmented } from '../StepInspector.jsx';
import { ColSelect } from '../shared/ColSelect.jsx';

export function ParseDateInspector({ step, onChange }) {
  const c = step.config || {};
  const u = (patch) => onChange({ ...step, config: { ...c, ...patch } });
  return (
    <div>
      <FieldLabel>Column</FieldLabel>
      <ColSelect value={c.column} onChange={(v) => u({ column: v })} />
      <FieldLabel>Output format</FieldLabel>
      <Segmented
        value={c.format || 'ISO'}
        onChange={(v) => u({ format: v })}
        options={[
          { value: 'ISO', label: 'ISO · 2026-05-23' },
          { value: 'US', label: 'US · 5/23/2026' },
          { value: 'EU', label: 'EU · 23/5/2026' },
        ]}
      />
      <FieldLabel hint="Override auto-detection">Input format hint (optional)</FieldLabel>
      <TextInput mono value={c.inputFormat} onChange={(v) => u({ inputFormat: v })} placeholder="e.g. %Y-%m-%d %H:%M:%S" />
      <FieldLabel>Timezone</FieldLabel>
      <Select
        value={c.tz || 'utc'}
        onChange={(v) => u({ tz: v })}
        options={[
          { value: 'utc', label: 'UTC' },
          { value: 'local', label: 'Local time' },
          { value: 'src', label: 'Source-specified' },
        ]}
      />
    </div>
  );
}
